import { Mutator } from 'final-form';

export { parseNumber } from '@occc/ui-forms';

export const clearFormField: Mutator<any> = ([name], state, { changeValue }) => {
  changeValue(state, name, () => undefined);
};

export const getFieldArrayIndex = (path: string) => {
  return parseInt(path.split('[')[1].split(']')[0], 10);
};

export const formatUpperCase = (value: unknown): string => {
  if (typeof value === 'string') return value.toUpperCase();
  return '';
};
